import wild_1 from "../assets/bonus/wilds.png";
import Crystal from "../assets/bonus/crystal.png";
import Heart from "../assets/bonus/heart.png";
import Star from "../assets/bonus/star.png";
import Bonuses from "../assets/bonus/bonuses.png";

// import { GameConfigs } from "../../lib/globals/GameConfigs";

export const WILDS = [wild_1];
export const PROGRESSIVE = [Bonuses];

export const TEXTS = {
  symbols: [
    {
      title: "Symbol Payout",
      desc: "The quantity and types of symbols on the line will determine your wins.",
    },
  ],
  additional_symbols: [
    {
      title: "Wild",
      desc: "Wild symbol substitutes all symbols except the Scatter symbol and works for Payline creation.",
    },
    {
      title: "Scatter",
      desc: "If 3 or more Scatter symbols land on the Reel, they will trigger the Bonus Game regardless of their position.",
    },
  ],
  paylines: [
    {
      title: "winning paylines",
      desc: "You have 10 consecutive Paylines to land symbols on and determine wins.",
    },
  ],
  features: [
    {
      title: "double chance & buy bonus",
      double_desc_1:
        "Switching the option doubles your chances of triggering the necessary scatters (3, 4, or 5) for the bonus round.",
      double_desc_2: "This option will increase your bet amount by",
      bonus_desc_1:
        "The Bonus Game can immediately triggered from the base game by buying it",
      bonus_desc_2: "The price for Buy Bonus is",
      bonus_desc_3: "of the bet amount.",
    },
  ],
};

export const BONUS_DESC_1 = ({ minfs }) => {
  return (
    <>
      <div>
        If <span className="blue">3</span> or more{" "}
        <span className="yellow">Scatter </span>symbols land on the Reel, it
        will trigger a <span className="purple">Bonus Game </span>
      </div>
      <div>
        The <span className="yellow">Scatter </span>symbol has payout values,
        which are determined by the number of them landed on the Reel
      </div>
      <div>
        <span className="purple">Bonus Game </span> is rewarded with{" "}
        <span className="blue">{minfs} Bonus Spins</span> determined by quantity
        of <span className="yellow">Scatter</span> symbols landed on the Reel
        and has <span className="pink">Progressive </span>rewarding gameplay.
      </div>
      <div>
        The <span className="purple">Bonus Game </span> has a chance to trigger{" "}
        <span className="yellow">Scatter</span> symbols which grants additional
        <span className="blue">{minfs} Bonus Spins</span> during existing{" "}
        <span className="purple">Bonus Game </span> session, the amount of{" "}
        <span className="blue">{minfs} Bonus Spins </span>are determined by
        quantity of the <span className="yellow">Scatter</span> symbols landed
        on the Reel.
      </div>
      <div>
        <span className="pink">Wild</span> symbols are sticky in the{" "}
        <span className="purple">Bonus Game </span>
      </div>
    </>
  );
};

export const BONUS_DESC_2 = () => {
  return (
    <>
      <div>
        Whenever <span className="purple">2</span> or more{" "}
        <span className="pink">Wild</span> Symbols land on Reel, its Multiplier
        is increased by <span className="purple">1x</span>
      </div>
      <div>
        Maximum amount of Multiplier possible is{" "}
        <span className="purple">5x</span>{" "}
      </div>
    </>
  );
};

export const PROGRESSIVE_DESC_1 = () => {
  return (
    <>
      <div>
        The <span className="purple">Bonus Game</span> offers a chance to land a{" "}
        <span className="purple">
          Special <img src={Crystal} alt="crystal" />
        </span>{" "}
        symbol on the reel, which adds{" "}
        <span className="yellow">+1 Bonus Spin</span> and advances you to the
        next step at progress platforms.
      </div>
      <div>
        The{" "}
        <span className="purple">
          Special <img src={Crystal} alt="crystal" />
        </span>{" "}
        symbol doesn't have any payout value.
      </div>
    </>
  );
};

export const PROGRESSIVE_DESC_2 = () => {
  return (
    <>
      <div>
        After <span className="purple">3 Steps,</span> you will catch the{" "}
        <span className="pink">
          Heart <img src={Heart} alt="heart" />{" "}
        </span>{" "}
        symbol and get rewarded with{" "}
        <span className="yellow">+5 Bonus Spins</span>
      </div>
      <div>
        After <span className="purple">completing</span> all progress platforms,
        you will get the{" "}
        <span className="yellow">
          Star <img src={Star} alt="star" />{" "}
        </span>
        symbol get rewarded with a <span className="pink">10x Multiplier</span>{" "}
        of your <span className="purple">Bonus Game</span> winnings.
      </div>
    </>
  );
};

export const QUEST_DESC_1 = () => {
  return (
    <>
      <div>
        The game has a quest system that allows you to receive specific rewards
        after completing predetermined tasks.
      </div>
    </>
  );
};

export const QUEST_DESC_2 = () => {
  return (
    <>
      <div>
        The quest section is shown on the main game board called "THE LOST
        SCROLL," with a timer telling how much time is left for the quest to
        reset.
      </div>
      <br />
      <div>
        The quest system consists of 4 sub-quests, and you should complete all 4
        sub-quests to receive the rewards.
      </div>
      <br />
      <div>
        The quests will reset every week. If you fail to complete all the quests
        before the reset, the system will reset your progress also, and you will
        have to complete the quests again.
      </div>
      <br />
      <div>
        The quest system's sub-quests entail in-game actions such as increasing
        the Bet, determining the number of bets, and catching a specific symbol
        multiple times.
      </div>
    </>
  );
};

export const SPECS_DESC_1 = () => {
  return (
    <>
      <div>
        The current game's volatility is High, which means that the game pays
        out less frequently, but the chances of big wins are increased.
      </div>
      <br />
      <div>
        The max win is 5000X of your Bet, applicable in base and bonus rounds.
      </div>
    </>
  );
};

export const SPECS_DESC_2 = (rtp) => {
  return (
    <>
      <div>
        If the game reaches the 5000X limit, the game will end immediately,
        grant the win, and cancel any remaining spins.
      </div>
      <br />
      <div>The Theoretical RTP of this game is {rtp}%</div>
      <br />
      <div>Any misuse or malfunction will void all wins and plays.</div>
      <br />
      <div>
        The game's random number generator determines the probabilities of
        stopping the Reel at any particular position.
      </div>
      <br />
      <div>
        In case of a connection issue, the game will continue from the point at
        which the issue occurred.
      </div>
      <br />
      <div>Game Rules Generated 2025-05-12 17:24 UTC</div>
      <div>Game Version 1.0.0.</div>
    </>
  );
};

